import React from 'react';
import { Container, TriangleIcon, ContentWrapper } from './stylesV2';

interface Iprops {
  title?: string;
  content?: string;
  leftText?: string;
  rightText?: string;
}
export const Description: React.FC<Iprops> = ({ title, leftText, rightText, content }) => {
  return (
    <Container>
      <TriangleIcon />
      <ContentWrapper isColumn={!!leftText}>
        <h1 className='resizeable-accessibility'>{title}</h1>
        <section >

          {content && (
            <p className='resizeable-accessibility'>
              {content}
            </p>

          )}

          {!content && (
            <>
              <p className='resizeable-accessibility'>
                {leftText}
              </p>
              <p className='resizeable-accessibility'>
                {rightText}
                {content}
              </p>
            </>
          )}

        </section>
      </ContentWrapper>
    </Container>
  );
};
